import { render, staticRenderFns } from "./ReservaFincaConsolidado.vue?vue&type=template&id=b8e72888&"
import script from "./ReservaFincaConsolidado.vue?vue&type=script&lang=js&"
export * from "./ReservaFincaConsolidado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports